import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';

import ChartTitle from '../../ChartTitle/ChartTitle';

import { vulsPeriodLineChartOptions } from './chartOptions';

import { useGetTotalEatenBaitLineChartState } from 'hooks/Analitics/SBSCharts/1_TotalEatenBaitLineChart/useGetTotalEatenBaitChartState';

interface ChartProps {
  slug: string;
}

const TotalEatenBaitLineChart: React.FC<ChartProps> = ({ slug }) => {
  const {
    period,
    startDate,
    endDate,
    showCustom,
    chartData,
    handlePeriodChange,
    setStartDate,
    setEndDate,
    step,
    setStep,
  } = useGetTotalEatenBaitLineChartState({ slug });
  const { t } = useTranslation();
  const chartOptions = vulsPeriodLineChartOptions(chartData, t);

  return (
    <div className="card m-0 border border-2 rounded-4 position-relative">
      <div className="card-header rounded-4">
        <ChartTitle
          title={t('ChartsAnalitics.bait_chart.title')}
          period={period}
          handlePeriodChange={handlePeriodChange}
          startDate={startDate}
          setStartDate={setStartDate}
          showCustom={showCustom}
          endDate={endDate}
          setEndDate={setEndDate}
          showStepFilter
          step={step}
          setStep={setStep}
        />
      </div>
      <div className="card-body">
        <div className="position-relative">
          <ReactApexChart options={chartOptions} series={chartOptions.series} type="area" height={350} />
        </div>
      </div>
    </div>
  );
};

export default TotalEatenBaitLineChart;
